import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AnimationService } from 'src/app/utils/animation.service';
import { Constants } from '../../utils/constants';

@Component({
  selector: 'app-campus-first',
  templateUrl: './campus-first.component.html',
  styleUrls: ['../home.component.scss', './campus-first.component.scss']
})
export class CampusFirstComponent implements OnInit {
  salesianaRedirectUrl: string = Constants.salesianaRedirectUrl;
  jalasoftRedirectUrl: string = Constants.jalasoftRedirectUrl;

  @ViewChild('toolsAnimation')
  toolsAnimation: ElementRef;

  constructor(private animation: AnimationService) { }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    this.animation.startLeftToRightAnimation(this.toolsAnimation.nativeElement);
  }
}
